import React, { FC } from "react";
import { format } from "date-fns";
import { parseTemplateAsString } from "../../../../helpers/localization";
import { ComponentsLocalization } from "../../../../types/graphql/generated";
import { ExchangeIconSvg } from "../../../icons";
import {
  StyledExchangeDetails,
  StyledExchangeLogo,
  StyledExchangeReturnByDate,
  StyledReturnBy,
} from "./index.styled";

interface ExchangeReturnByDateProps {
  returnDueDate: string;
  componentLocalization: ComponentsLocalization["exchangeReturnByDate"];
}

export const ExchangeReturnByDate: FC<ExchangeReturnByDateProps> = ({
  returnDueDate,
  componentLocalization,
}) => {
  const {
    exchangeText = "Exchange",
    // eslint-disable-next-line no-template-curly-in-string
    returnByText = "Return by ${returnDueDate}",
  } = componentLocalization ?? {};

  return (
    <StyledExchangeReturnByDate>
      <StyledExchangeLogo>
        <ExchangeIconSvg />
      </StyledExchangeLogo>
      <StyledExchangeDetails>
        <div>{exchangeText}</div>
        <StyledReturnBy>
          {parseTemplateAsString(returnByText, {
            returnDueDate: format(new Date(returnDueDate), "PP"),
          })}
        </StyledReturnBy>
      </StyledExchangeDetails>
    </StyledExchangeReturnByDate>
  );
};
